import _styled from "styled-components";
import React from "react";

var IconContainer = _styled.button.withConfig({
  displayName: "ToggleButton__IconContainer",
  componentId: "sc-1ryiem6-0"
})(["background-color:", ";border:none;width:80px;height:80px;outline:none;border-radius:50%;"], function (props) {
  return props.active ? "#4d9adf" : "transparent";
});

export function ToggleButton(_ref) {
  var disabled = _ref.disabled,
      active = _ref.active,
      onClick = _ref.onClick,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconContainer, {
    active: active,
    onClick: disabled ? undefined : onClick
  }, children));
}